module.exports = __webpack_public_path__ + "static/img/RPA-C-01-21_5.e909270.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RPA-C-01-21_5.jpeg
// module id = gnDS
// module chunks = 9